<div class="scrollable-wrapper">
  <div class="scrollable" (mousedown)="onDragStart($event)" (mousemove)="onDragMove($event)">
    <div class="content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
